import { SyntheticEvent, useState } from 'react';

export const STORAGE_KEY = 'copro.home.activeTab';
export const TAB_COUNT = 2;

export function readStoredTab(storage?: Pick<Storage, 'getItem'>): number {
  try {
    const store = storage ?? (typeof window !== 'undefined' ? window.localStorage : undefined);
    if (!store) {
      return 0;
    }
    const raw = store.getItem(STORAGE_KEY);
    if (raw === null) {
      return 0;
    }
    const parsed = Number(raw);
    return Number.isInteger(parsed) && parsed >= 0 && parsed < TAB_COUNT ? parsed : 0;
  } catch {
    return 0;
  }
}

export function writeStoredTab(value: number, storage?: Pick<Storage, 'setItem'>): void {
  try {
    const store = storage ?? (typeof window !== 'undefined' ? window.localStorage : undefined);
    if (!store) {
      return;
    }
    store.setItem(STORAGE_KEY, String(value));
  } catch {
    // Ignore storage failures (private mode, quota); tab still updates in-session.
  }
}

export function usePendingSubTopicPage() {
  const [activeTab, setActiveTab] = useState<number>(readStoredTab);

  function handleTabChange(_event: SyntheticEvent, value: number) {
    setActiveTab(value);
    writeStoredTab(value);
  }

  return { activeTab, handleTabChange };
}

